import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { InfoSet } from "../InfoSets/InfoSet";
import { StringUtils } from "../Utils/StringUtils";
import { Dictionary } from "../Utils/Dictionary";
import { Device } from "../Core/Device";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export enum AssetPhysicalClass {
	other = 1,
	unknown,
	chassis,
	backplane,
	container,
	powerSupply,
	fan,
	sensor,
	module,
	port,
	stack,
	cpu
};
	
//export interface AssetEntryJsonWrapper {
//	asset_entry: AssetEntryJson;
//}

//export interface AssetEntryJson {
//	index: string;
//    name: string;
//    description: string;
//	ent_physical_index: string;
//	vendor_asset_key: string;
//	vendor_type: string;
//	contained_in: string;
//	class: string;
//	parent_rel_pos: string;
//	hw_rev: string;
//	fw_rev: string;
//	sw_rev: string;
//	serial_number: string;
//	manufacturer_name: string;
//	model: string;
//	alias: string;
//	asset_id: string;
//	fru: string;
//	status: string;
//	switch_index: string;
//    unit_index: string;
//    module_index: string;
//    sub_module_index: string;
//    sub_sub_module_index: string;
//    num_ports: string;
//}

export class AssetEntry implements ObjectSerializer {
	//public static FromJson(json: AssetEntryJson):AssetEntry {
	//	var result = new AssetEntry(parseInt(json.index));

 //       if (json.index !== undefined)
 //           result.Index = parseInt(json.index);
 //       if (json.name !== undefined)
 //           result.Name = json.name;
 //       if (json.description !== undefined)
 //           result.Description = json.description;
 //       if (json.ent_physical_index !== undefined)
 //           result.EntPhysicalIndex = parseInt(json.ent_physical_index);
 //       if (json.vendor_asset_key !== undefined)
 //           result.VendorAssetKey = json.vendor_asset_key;
 //       if (json.vendor_type !== undefined)
 //           result.VendorType = json.vendor_type;
 //       if (json.contained_in !== undefined)
 //           result.ContainedIn = parseInt(json.contained_in);
 //       if (json.class !== undefined)
 //           result.Class = AssetPhysicalClass[json.class];
 //       if (json.parent_rel_pos !== undefined)
 //           result.ParentRelPos = parseInt(json.parent_rel_pos);
 //       if (json.hw_rev !== undefined)
 //           result.HwRev = json.hw_rev;
 //       if (json.fw_rev !== undefined)
 //           result.FwRev = json.fw_rev;
 //       if (json.sw_rev !== undefined)
 //           result.SwRev = json.sw_rev;
 //       if (json.serial_number !== undefined)
 //           result.SerialNum = json.serial_number;
 //       if (json.manufacturer_name !== undefined)
 //           result.MfgName = json.manufacturer_name;
 //       if (json.model !== undefined)
 //           result.ModelName = json.model;
 //       if (json.alias !== undefined)
 //           result.Alias = json.alias;
 //       if (json.asset_id !== undefined)
 //           result.AssetID = json.asset_id;
 //       if (json.fru !== undefined)
 //           result.IsFRU = StringUtils.ParseBool(json.fru);
 //       if (json.status !== undefined)
 //           result.Status = json.status;
 //       if (json.switch_index !== undefined)
 //           result.SwitchIndex = parseInt(json.switch_index);
 //       if (json.unit_index !== undefined)
 //           result.UnitIndex = parseInt(json.unit_index);
 //       if (json.module_index !== undefined)
 //           result.ModuleIndex = parseInt(json.module_index);
 //       if (json.sub_module_index !== undefined)
 //           result.SubModuleIndex = parseInt(json.sub_module_index);
 //       if (json.sub_sub_module_index !== undefined)
 //           result.SubSubModuleIndex = parseInt(json.sub_sub_module_index);
 //       if (json.num_ports !== undefined)
 //           result.NumPorts = parseInt(json.num_ports);

	//	return result;
	//}

	// KEY
	public Index: number;

	// ATTRIBUTES
	public EntPhysicalIndex: number;
	public get HasEntPhysicalIndex() {
		return this.EntPhysicalIndex >= 0;
	}

	public VendorAssetKey:string;
	public get HasVendorAssetKey():boolean { 
		return !!this.VendorAssetKey;
	}

	public Name:string;
	public get HasName(): boolean {
		return !!this.Name;
	}
		

	public Description: string;
	public get HasDescription(): boolean {
		return !!this.Description;
	}
		
	public VendorType: string;
	public get HasVendorType(): boolean {
		return !!this.VendorType;
	}

	public ContainedIn: number;
	public get HasContainedIn():boolean {
		return this.ContainedIn >= 0;
	}

	public Class: AssetPhysicalClass;

	public ParentRelPos: number;
	public get HasParentRelPos():boolean {
		return this.ParentRelPos >= 0;
	}

	public HwRev: string;
	public get HasHwRev(): boolean {
		return !!this.HwRev;
	}

	public FwRev: string;
	public get HasFwRev(): boolean {
		return !!this.FwRev;
	}

	public SwRev: string;
	public get HasSwRev(): boolean {
		return !!this.SwRev;
	}

	public SerialNum: string;
	public get HasSerialNum(): boolean {
		return !!this.SerialNum;
	}

	public MfgName: string;
	public get HasMfgName(): boolean {
		return !!this.MfgName;
	}

	public ModelName: string;
	public get HasModelName(): boolean {
		return !!this.ModelName;
	}

	public Alias: string;
	public get HasAlias(): boolean {
		return !!this.Alias;
	}

	public AssetID: string;
	public get HasAssetID(): boolean {
		return !!this.AssetID;
	}

	public IsFRU:boolean

	public Status: string;
	public get HasStatus(): boolean { 
		return !!this.Status;
	}

	public SwitchIndex: number;
	public get HasSwitchIndex(): boolean {
		return this.SwitchIndex >= 0;
	}

	public UnitIndex: number;
	public get HasUnitIndex(): boolean {
		return this.UnitIndex >= 0;
	}

	public ModuleIndex: number;
	public get HasModuleIndex(): boolean {
		return this.ModuleIndex >= 0;
	}

	public SubModuleIndex: number;
	public get HasSubModuleIndex(): boolean {
		return this.SubModuleIndex >= 0;
	}
		
	public SubSubModuleIndex: number;
	public get HasSubSubModuleIndex(): boolean {
		return this.SubSubModuleIndex >= 0;
	}

	public NumPorts: number;
	public get HasNumPorts(): boolean {
		return (!!this.NumPorts && this.NumPorts > 0);
	}
		
	constructor(assetIndex?: number) {
		this.Index = assetIndex;
		this.Init();
	}

	private Init(): void {
		this.EntPhysicalIndex = -1;
		this.VendorAssetKey = '';
		this.VendorType = '';
		this.ContainedIn = -1;
		this.Class = AssetPhysicalClass.unknown;
		this.ParentRelPos = -1;
		this.Name = '';
		this.HwRev = '';
		this.FwRev = '';
		this.SwRev = '';
		this.SerialNum = '';
		this.MfgName = '';
		this.ModelName = '';
		this.Alias = '';
		this.AssetID = '';
		this.IsFRU = false;
		this.Status = '';

		this.SwitchIndex = -1;
		this.UnitIndex = -1;
		this.ModuleIndex = -1;
		this.SubModuleIndex = -1;
		this.SubSubModuleIndex = -1;
		this.NumPorts = 0;

		this.ClearContainment();
	}

	public ClearContainment(): void {
		this.UnitIndex = -1;
		this.ModuleIndex = -1;
		this.SubModuleIndex = -1;
		this.SubSubModuleIndex = -1;
	}

	public get IsPort() {
		return this.Class == AssetPhysicalClass.port;
	}

	public Equals(obj: AssetEntry): boolean {
		if (obj == null)
			return false;

		if (obj == this)
			return true;

		if (!(obj instanceof AssetEntry))
			return false;

		var other = <AssetEntry> obj;
		return obj.Index == this.Index;
	}

	public GetHashCode(): number {
		return ObjUtils.GetHashCode(this.Index);
	}

	public Write(obj: any, context: any): void {
		obj.asset_entry = {};
		obj = obj.asset_entry;

		obj.index = ValueEncoder.EncodeInteger(this.Index);

		if (this.HasEntPhysicalIndex)
			obj.ent_physical_index = ValueEncoder.EncodeInteger(this.EntPhysicalIndex);

		if (this.HasVendorAssetKey)
			obj.vendor_asset_key = this.VendorAssetKey;

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasVendorType)
			obj.vendor_type = this.VendorType;

		if (this.HasContainedIn)
			obj.contained_in = ValueEncoder.EncodeInteger(this.ContainedIn);

		obj.class = ValueEncoder.EncodeInteger(this.Class);

		if (this.HasParentRelPos)
			obj.parent_rel_pos = ValueEncoder.EncodeInteger(this.ParentRelPos);

		if (this.HasHwRev)
			obj.hw_rev = this.HwRev;

		if (this.HasFwRev)
			obj.fw_rev = this.FwRev;

		if (this.HasSwRev)
			obj.sw_rev = this.SwRev;

		if (this.HasSerialNum)
			obj.serial_number = this.SerialNum;

		if (this.HasMfgName)
			obj.manufacturer_name = this.MfgName;

		if (this.HasModelName)
			obj.model = this.ModelName;

		if (this.HasAlias)
			obj.alias = this.Alias;

		if (this.HasAssetID)
			obj.asset_id = this.AssetID;

		obj.fru = ValueEncoder.EncodeBoolean(this.IsFRU);

		if (this.HasStatus)
			obj.state = this.Status; // (sic)

		if (this.HasSwitchIndex)
			obj.switch_index = ValueEncoder.EncodeInteger(this.SwitchIndex);

		if (this.HasUnitIndex)
			obj.unit_index = ValueEncoder.EncodeInteger(this.UnitIndex);

		if (this.HasModuleIndex)
			obj.module_index = ValueEncoder.EncodeInteger(this.ModuleIndex);

		if (this.HasSubModuleIndex)
			obj.sub_module_index = ValueEncoder.EncodeInteger(this.SubModuleIndex);

		if (this.HasSubSubModuleIndex)
			obj.sub_sub_module_index = ValueEncoder.EncodeInteger(this.SubSubModuleIndex);

		if (this.HasNumPorts)
			obj.num_ports = ValueEncoder.EncodeInteger(this.NumPorts);
	}

	public Read(obj: any, context: any): void {
		if (!obj.asset_entry)
			throw new Error();
		obj = obj.asset_entry;

		if (obj.index !== undefined)
			this.Index = ValueEncoder.DecodeInteger(obj.index);

        if (obj.name !== undefined)
			this.Name = obj.name;

        if (obj.description !== undefined)
			this.Description = obj.description;

        if (obj.ent_physical_index !== undefined)
			this.EntPhysicalIndex = ValueEncoder.DecodeInteger(obj.ent_physical_index);

        if (obj.vendor_asset_key !== undefined)
			this.VendorAssetKey = obj.vendor_asset_key;

        if (obj.vendor_type !== undefined)
			this.VendorType = obj.vendor_type;

        if (obj.contained_in !== undefined)
			this.ContainedIn = ValueEncoder.DecodeInteger(obj.contained_in);

        if (obj.class !== undefined)
			this.Class = ValueEncoder.DecodeInteger(obj.class);

        if (obj.parent_rel_pos !== undefined)
			this.ParentRelPos = ValueEncoder.DecodeInteger(obj.parent_rel_pos);

        if (obj.hw_rev !== undefined)
			this.HwRev = obj.hw_rev;

        if (obj.fw_rev !== undefined)
			this.FwRev = obj.fw_rev;

        if (obj.sw_rev !== undefined)
			this.SwRev = obj.sw_rev;

        if (obj.serial_number !== undefined)
			this.SerialNum = obj.serial_number;

        if (obj.manufacturer_name !== undefined)
			this.MfgName = obj.manufacturer_name;

        if (obj.model !== undefined)
			this.ModelName = obj.model;

        if (obj.alias !== undefined)
			this.Alias = obj.alias;

        if (obj.asset_id !== undefined)
			this.AssetID = obj.asset_id;

        if (obj.fru !== undefined)
			this.IsFRU = ValueEncoder.DecodeBoolean(obj.fru);

        if (obj.state !== undefined)	// (sic)
			this.Status = obj.state;

        if (obj.switch_index !== undefined)
			this.SwitchIndex = ValueEncoder.DecodeInteger(obj.switch_index);

        if (obj.unit_index !== undefined)
			this.UnitIndex = ValueEncoder.DecodeInteger(obj.unit_index);

        if (obj.module_index !== undefined)
			this.ModuleIndex = ValueEncoder.DecodeInteger(obj.module_index);

        if (obj.sub_module_index !== undefined)
			this.SubModuleIndex = ValueEncoder.DecodeInteger(obj.sub_module_index);

        if (obj.sub_sub_module_index !== undefined)
			this.SubSubModuleIndex = ValueEncoder.DecodeInteger(obj.sub_sub_module_index);

        if (obj.num_ports !== undefined)
			this.NumPorts = ValueEncoder.DecodeInteger(obj.num_ports);
	}
}

export class VersionInfo {
	constructor(
		public hwVersion: string = '',
		public swVersion: string = '',
		public fwVersion: string = ''
		) {

	}
}
	
export class AssetTable extends InfoSet implements Iterable<AssetEntry> {
	//public static FromJson(json: InfoSetEntriesJson<AssetEntryJsonWrapper>, device: Device):AssetTable {
	//	var result = new AssetTable(device);

	//	json.entries.forEach((entryJson) => {
	//		result.AddEntry(AssetEntry.FromJson(entryJson.asset_entry));
	//	});

	//	return result;
	//}

	public ToArray(): AssetEntry[] {
		return this._assetTable.Values().Values;
	}

	private _assetTable: Dictionary<number, AssetEntry>;

	constructor(device: Device) {
		super(device);
		this._assetTable = new Dictionary<number, AssetEntry>();
	}

	private GetNextIndex(): number {
		var nextIndex = 0;

		this._assetTable.ForEach((pair) => {
			if (nextIndex >= pair.Value.Index)
				return;
			nextIndex = pair.Value.Index;
		});

		if (nextIndex < 0)
			nextIndex = 0;

		nextIndex++;

		return (nextIndex);
	}

	public Add(): AssetEntry {
		var assetIndex: number = this.GetNextIndex();
		return this.AddByIndex(assetIndex);
	}

	public AddByClass(assetClass: AssetPhysicalClass): AssetEntry {
		var assetEntry: AssetEntry = null;

		var assetIndex: number = this.GetNextIndex();

		assetEntry = this.AddByIndex(assetIndex);
		if (assetEntry != null) {
			assetEntry.Class = assetClass;
		}

		return (assetEntry);
	}

	public AddByIndex(assetIndex: number): AssetEntry {
		var assetEntry: AssetEntry = null;

		assetEntry = this._assetTable.Item(assetIndex);
		if (!assetEntry) {
			assetEntry = new AssetEntry(assetIndex);
			this._assetTable.Add(assetIndex, assetEntry);
		}

		return assetEntry;
	}

	public AddEntry(assetEntry: AssetEntry): void {
		if (assetEntry == null)
			return;
		if (assetEntry.Index < 0)
			return;

		this._assetTable.Remove(assetEntry.Index);

		this._assetTable.Add(assetEntry.Index, assetEntry);
	}

	public AddChassis(switchIndex: number = -1): AssetEntry {
		var chassisEntry: AssetEntry = null;

		chassisEntry = this.FindChassis(switchIndex);
		if (chassisEntry == null) {
			chassisEntry = this.AddByClass(AssetPhysicalClass.chassis);
			if (switchIndex >= 0)
				chassisEntry.SwitchIndex = switchIndex;
		}

		return (chassisEntry);
	}

	public FindChassis(switchIndex: number = -1): AssetEntry {
		var chassisEntry: AssetEntry = null;

		this._assetTable.Some((pair) => {
			if (pair.Value.Class != AssetPhysicalClass.chassis)
				return;

			if (switchIndex >= 0) {
				if (pair.Value.SwitchIndex != switchIndex)
					return;
			}

			chassisEntry = pair.Value;
			return true;
		});

		return (chassisEntry);
	}

	public AddModule(moduleIndex: number): AssetEntry {
		var moduleEntry: AssetEntry = null;

		moduleEntry = this.FindModuleByIndex(moduleIndex);
		if (moduleEntry == null) {
			moduleEntry = this.AddByClass(AssetPhysicalClass.module);
			if (moduleEntry != null) {
				moduleEntry.ModuleIndex = moduleIndex;
			}
		}

		return (moduleEntry);
	}

	public FindModule(switchIndex: number, moduleIndex: number): AssetEntry {
		var moduleEntry: AssetEntry = null;

		this._assetTable.Some((pair) => {
			var assetEntry: AssetEntry = pair.Value;
			if (assetEntry.Class != AssetPhysicalClass.module)
				return;

			if (assetEntry.SwitchIndex != switchIndex)
				return;

			if (assetEntry.ModuleIndex != moduleIndex)
				return;

			moduleEntry = assetEntry;
			return true;
		});

		return (moduleEntry);
	}

	public FindModuleByIndex(moduleIndex: number): AssetEntry {
		return (this.FindModule(-1, moduleIndex));
	}

	public AddPowerSupply(powerSupplyIndex: number): AssetEntry {
		var powerSupplyEntry: AssetEntry = null;

		powerSupplyEntry = this.FindPowerSupply(powerSupplyIndex);
		if (powerSupplyEntry == null) {
			powerSupplyEntry = this.AddByClass(AssetPhysicalClass.powerSupply);
			if (powerSupplyEntry != null) {
				powerSupplyEntry.ParentRelPos = powerSupplyIndex;
				powerSupplyEntry.Name = "Power Supply " + powerSupplyIndex;
			}
		}

		return (powerSupplyEntry);
	}

	public FindPowerSupply(powerSupplyIndex: number): AssetEntry {
		var powerSupplyEntry: AssetEntry = null;

		this._assetTable.Some((pair) => {
			if (pair.Value.Class != AssetPhysicalClass.powerSupply)
				return;

			if (pair.Value.ParentRelPos != powerSupplyIndex)
				return;

			powerSupplyEntry = pair.Value;
			return true;
		});

		return (powerSupplyEntry);
	}

	public AddFan(fanIndex: number): AssetEntry {
		var fanEntry: AssetEntry = null;

		fanEntry = this.FindFan(fanIndex);
		if (fanEntry == null) {
			fanEntry = this.AddByClass(AssetPhysicalClass.fan);
			if (fanEntry != null) {
				fanEntry.ParentRelPos = fanIndex;
				fanEntry.Name = "Fan " + fanIndex;
			}
		}

		return (fanEntry);
	}

	public FindFan(fanIndex: number): AssetEntry {
		var fanEntry: AssetEntry = null;

		this._assetTable.Some((pair) => {
			if (pair.Value.Class != AssetPhysicalClass.fan)
				return;

			if (pair.Value.ParentRelPos != fanIndex)
				return;

			fanEntry = pair.Value;
			return true;
		});

		return (fanEntry);

	}

	public GetVersionInfo(): VersionInfo {
		var v: VersionInfo = new VersionInfo();
		this._assetTable.Some((pair) => {
			if (pair.Value.Class != AssetPhysicalClass.chassis)
				return;

			v.hwVersion = pair.Value.HwRev;
			v.swVersion = pair.Value.SwRev;
			v.fwVersion = pair.Value.FwRev;

			return true;
		});

		if (!v.hwVersion || !v.swVersion || !v.fwVersion) {
			this._assetTable.Some((pair) => {
				if (pair.Value.Class != AssetPhysicalClass.module)
					return;

				if (!v.hwVersion) {
					if (pair.Value.HasHwRev)
						v.hwVersion = pair.Value.HwRev;
				}

				if (!v.swVersion) {
					if (pair.Value.HasSwRev)
						v.swVersion = pair.Value.SwRev;
				}

				if (!v.fwVersion) {
					if (pair.Value.HasFwRev)
						v.fwVersion = pair.Value.FwRev;
				}

				if (!v.hwVersion && !v.swVersion && !v.fwVersion)
					return true;
			});
		}

		return v;
	}

	public Clear(): void {
		this._assetTable.Clear();
	}

	public get Count(): number {
		return this._assetTable.Count;
	}

	public SwitchCount(): number {
		var switchCount = 0;

		this._assetTable.ForEach((pair) => {
			if (pair.Value.Class != AssetPhysicalClass.stack)
				return;
			switchCount++;
		});

		return (switchCount);
	}

	public ModuleCount(): number {
		var moduleCount = 0;

		this._assetTable.ForEach((pair) => {
			if (pair.Value.Class != AssetPhysicalClass.module)
				return;
			moduleCount++;
		});

		return (moduleCount);
	}

	public Find(assetIndex: number): AssetEntry {
		return this._assetTable.Item(assetIndex);
	}

	public FindByVendorAssetKey(assetKey: string): AssetEntry {
		var foundAssetEntry: AssetEntry = null;

		if (!!assetKey) {
			this._assetTable.Some((pair) => {
				if (!pair.Value.HasVendorAssetKey)
					return;

				if (pair.Value.VendorAssetKey != assetKey)
					return;

				foundAssetEntry = pair.Value;
				return true;
			});
		}

		return (foundAssetEntry);
	}

	public Remove(assetIndex: number): boolean {
		return this._assetTable.Remove(assetIndex);
	}

	public RemoveEntry(assetEntry: AssetEntry): boolean {
		return assetEntry ? this._assetTable.Remove(assetEntry.Index) : false;
	}

	public ForEach(callbackfn: (value: AssetEntry, index: number, array: AssetEntry[]) => void, thisArg?: any): void {
		this._assetTable.Values().ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: AssetEntry, index: number, array: AssetEntry[]) => boolean, thisArg?: any): boolean {
		return this._assetTable.Values().Some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: AssetEntry, index: number, array: AssetEntry[]) => boolean, thisArg?: any): boolean {
		return this._assetTable.Values().Every(callbackfn, thisArg);
	}

	public Write(obj: any, context: any): void {
		obj.asset_info = {};
		obj = obj.asset_info;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._assetTable.Values(), context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.asset_info)
			throw new Error();
		obj = obj.asset_info;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new AssetEntry();
				entry.Read(value, context);
				this.AddEntry(entry);
			}, this);
		}
	}
}
